export default {
  STATUS: [
    { LABEL: 'Aprovada', VALUE: 'APPROVED' },
    { LABEL: 'Reprovada', VALUE: 'REPROVED' },
  ],
};
